module.exports = __webpack_public_path__ + "static/media/member-guide3.9eaaa2bf.png";